import { useCallback } from "react";
import { updateUserProfileService } from "~/services/api/services/klaviyo";

export const useUpdateKlaviyoUserProfile = () => {
    return useCallback((email: string, properties: Record<string, string>) => {
        if (!email || !properties) return Promise.resolve();

        const data = {
            type: "profile",
            attributes: { properties, email },
            meta: {
                patch_properties: {
                    append: { newKey: "New Value" },
                    unappend: { newKey: "New Value" }
                }
            }
        };

        return updateUserProfileService(data).catch(console.error);
    }, []);
}